import { createFeatureSelector } from "@ngrx/store";
import { AppState, coreModuleFeatureKey } from "./store";

export const selectCoreModule = createFeatureSelector<AppState>(
  coreModuleFeatureKey
);
